// AlertsClinicalWarningsCard.jsx

import React, { useEffect, useState } from "react";
import { FiShield } from "react-icons/fi";
import axiosInstance from "../../../axios/axios";
import { useParams } from "react-router-dom";
import moment from "moment";

import {
  Encrypt_Value,
  Decrypt_Value,
} from "../../../MiddleWare/EncryptDecrypt";

const AlertsClinicalWarningsCard = ({ onExportData }) => {
  const params = useParams();

  const [activeRisksData, setActiveRisksData] = useState([]);

  const fetchActiveRisks = () => {
    if (!params.pid) return;

    axiosInstance
      .get(`/vozo/patient/screening-active-risks/list?patient_id=${params.pid}`)
      .then((response) => {
        let data = response.data;

        try {
          data = Decrypt_Value(response.data, "vozo");
        } catch (decryptError) {}

        if (typeof data === "string") {
          data = JSON.parse(data);
        }

        if (data?.Status === "Success") {
          const list = Array.isArray(data.Data) ? data.Data : [];
          setActiveRisksData(list);

          if (onExportData) {
            onExportData(
              list.map((item) => ({
                testName: item.testName || "-",
                value: item.value || "-",
                triggeredOn: item.triggeredOn || "-",
                status: item.status || "-",
              })),
            );
          }
        } else {
          setActiveRisksData([]);
        }
      })
      .catch((error) => {
        console.error(error);
        setActiveRisksData([]);
      });
  };

  useEffect(() => {
    fetchActiveRisks();
  }, [params.pid]);

  const getStatusClass = (status) => {
    const s = (status || "").toLowerCase();
    if (s.includes("high")) {
      return "inactive-status";
    }

    if (
      s.includes("moderate") ||
      s.includes("medium") ||
      s.includes("warning")
    ) {
      return "warning-status";
    }

    return "active-status";
  };

  return (
    <div className="care-summary-card">
      <div className="care-summary-title-wrap">
        <FiShield className="care-summary-main-icon" />

        <h3 className="care-summary-title">Alerts & Clinical Warnings</h3>
      </div>

      <div className="care-summary-body">
        {activeRisksData.length > 0 ? (
          activeRisksData.slice(0, 3).map((item, index) => (
            <div
              key={item.id || index}
              className={`care-summary-row ${
                index !== activeRisksData.length - 1
                  ? "care-summary-border"
                  : ""
              }`}
            >
              <div className="care-summary-content">
                <div className="care-summary-heading">
                  {item.testName || "—"}
                </div>

                <div className="care-summary-subtext dark-sub">
                  Value: {item.value || "—"}
                </div>

                <div className="care-summary-subtext">
                  Triggered On:{" "}
                  {item.triggeredOn &&
                  moment(item.triggeredOn, "DD/MM/YYYY", true).isValid()
                    ? moment(item.triggeredOn, "DD/MM/YYYY").format(
                        "MMM DD, YYYY",
                      )
                    : "—"}
                </div>
              </div>

              <div
                className={`care-summary-status-wrap ${getStatusClass(
                  item.status,
                )}`}
              >
                <span className="care-summary-status-dot"></span>

                <span className="care-summary-status-text">
                  {item.status || "—"}
                </span>
              </div>
            </div>
          ))
        ) : (
          <div className="care-summary-subtext">
            No alerts & clinical warnings Added
          </div>
        )}
      </div>
    </div>
  );
};

export default React.memo(AlertsClinicalWarningsCard);
